import React, { Component } from 'react'

export class AsLegendColorContinuousPolygon extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidUpdate() {
    this.ref.current.data = this.props.data
  }

  render() {
    return (
      <as-legend-color-continuous-polygon ref={this.ref} slot={this.props.slot} orientation={this.props.orientation}></as-legend-color-continuous-polygon>
    )
  }
}

export default AsLegendColorContinuousPolygon
